export const getNoDataWarningStyles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  imageContainer: {
    height: 200,
    width: 200,
    borderRadius: 160,
    border: '0.64px #F0F0F0',
    background: '#FAF9F8',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    height: 128,
    width: 128,
  },
  keyHint: {
    fontWeight: 600,
    fontSize: 20,
    width: 300,
    marginTop: 18,
    textAlign: 'center',
  },
  description: {
    width: 300,
    textAlign: 'center',
    marginTop: 8,
  },
});
